import React, { ReactElement } from "react";
import { ToelichtingSocialeVoorzieningenHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import Heading from "../../components/Heading";
import { Paragraph } from "../../components/Paragraph";
import { Chapter } from "../../components/Chapter";
import "./socialevoorzieningen-chapter.scss";

type ToelichtingSocialeVoorzieningenProps = {
  toelichtingSocialeVoorzieningen: ToelichtingSocialeVoorzieningenHoofdstuk;
};

export const ToelichtingSocialeVoorzieningenChapter = ({
  toelichtingSocialeVoorzieningen,
}: ToelichtingSocialeVoorzieningenProps): ReactElement => {
  return (
    <Chapter>
      {toelichtingSocialeVoorzieningen.titel && (
        <Heading
          text={toelichtingSocialeVoorzieningen.titel}
        />
      )}

     
      {toelichtingSocialeVoorzieningen.paragrafen &&
        Object.keys(toelichtingSocialeVoorzieningen.paragrafen).map((key) => {
          const paragraaf = toelichtingSocialeVoorzieningen.paragrafen && toelichtingSocialeVoorzieningen.paragrafen[key];
          return (
            paragraaf && (
                <React.Fragment key={key}>                
                <Paragraph withMarkdown paragraaf={paragraaf}/>               
                </React.Fragment>
            )
          );
        })}
    
    </Chapter>
  );
};
